import React from 'react';
import { Deck, Slayt, Metrik, MetrikSira, Tablo, Not, Dagilim, GrupSeridi, tl } from './EylulSlaytKit';

/**
 * Keramet Ilıcası — Eylül 2026 medya planı. ÜÇ slayt.
 *
 * 🔑 Öneri bir AZALTMA + KAYDIRMA: Ağustos ₺189.341 → ₺120.000 (−%36,6),
 *    ama Google payı ₺16.429 → ₺45.000 (2,7×). Gerekçe: günübirlik açık termal
 *    havuz talebi Eylül'de bitiyor ("kaplıca" −%33), buna karşılık Ağustos'ta
 *    harcanan para MARKA TALEBİ yarattı ve o talep Google'da sahipsiz duruyor.
 *
 * 🔴 Keramet Ilıcası `Brand` tablosunda kayıtlı DEĞİL; rota allowBrandIds ile
 *    değil requireBrand={false} + allowEmails ile kilitlenir.
 * 🔴 Hesapta lead/form dönüşümü tanımlı DEĞİL — Ağustos'un tek ölçülebilir
 *    sonucu erişim. Bu sayfada ziyaret/ciro projeksiyonu BİLEREK VERİLMEDİ.
 *
 * Kaynak: Keyword Planner (geo TR 2792 ve Bursa 21060, GOOGLE_SEARCH, çekim
 * 31 Ağu 2026) + /api/group/hupalupa/monthly (canlı Meta act_2095088354756210,
 * Google 6654294370). ⚠️ Ağustos 31 Ağu 14:29 (TR) itibarıyla; son yarım gün eksik.
 */

export default function KerametIlicasiEylul2026() {
  return (
    <Deck
      marka="Keramet Ilıcası"
      altBaslik="Orhangazi / Bursa · günübirlik açık termal havuz · Meta + Google Ads"
      logo="/logos/grup/keramet.png"
      logoBg="bg-white border border-gray-200"
      butce={120000}
      oncekiButce={189341}
    >
      {/* ════════════ SLAYT 1 — TALEP ════════════ */}
      <Slayt
        no={1}
        etiket="Slayt 1 · Talep"
        accent="#B45309"
        baslik="Günübirlik havuz sezonu kapanıyor, ama termal talebi bitmiyor — yön değiştiriyor."
        spot="Eylül'de &quot;kaplıca&quot; sorgusu iki yıl üst üste üçte bir geriliyor. Aynı anda &quot;termal otel&quot; ve &quot;kaplıca otelleri&quot; yükseliyor. Yani insanlar termalden vazgeçmiyor; günübirlik havuzdan konaklamalı termale geçiyor. Eylül planı bu geçişi izlemeli."
        dipnot="Kaynak: Google Ads Keyword Planner, dil Türkçe, yalnızca Google Arama. Türkiye geneli (geoTargetConstants/2792) ve Bursa (21060) ayrı ayrı çekildi. Planner değerleri sabit bucket'lardan gelir."
      >
        <MetrikSira kolon={4}>
          <Metrik etiket="&quot;kaplıca&quot; Eylül" deger="−%33" alt="33.100 → 22.200 · 2024'te de −%33" ton="kotu" />
          <Metrik etiket="&quot;termal otel&quot; Eylül" deger="+%22" alt="33.100 → 40.500" ton="iyi" />
          <Metrik etiket="&quot;termal otel&quot; · Bursa" deger="+%26" alt="1.900 → 2.400" ton="iyi" />
          <Metrik etiket="&quot;kaplıca otelleri&quot; Eylül" deger="+%22" alt="5.400 → 6.600" ton="iyi" />
        </MetrikSira>

        <Tablo
          baslik="Termal talebi — Ağustos → Eylül aylık arama hacmi"
          basliklar={['Kelime', 'Bölge', 'Ağu 2025', 'Eyl 2025', 'Değişim', 'Yön']}
          saga={[2, 3, 4]}
          satirlar={[
            [{ v: 'kaplıca', kalin: true }, 'Türkiye', '33.100', '22.200', { v: '−%33', ton: 'kotu', kalin: true }, 'günübirlik ↓'],
            ['termal havuz', 'Türkiye', '1.900', '1.300', { v: '−%32', ton: 'kotu' }, 'günübirlik ↓'],
            [{ v: 'keramet ılıcası', kalin: true }, 'Türkiye', '1.900', '1.000', { v: '−%47', ton: 'kotu' }, 'geçen yılın deseni'],
            [{ v: 'termal otel', kalin: true }, 'Türkiye', '33.100', '40.500', { v: '+%22', ton: 'iyi', kalin: true }, 'konaklama ↑'],
            ['kaplıca otelleri', 'Türkiye', '5.400', '6.600', { v: '+%22', ton: 'iyi' }, 'konaklama ↑'],
            ['termal tatil', 'Türkiye', '590', '720', { v: '+%22', ton: 'iyi' }, 'konaklama ↑'],
            ['termal otel', 'Bursa', '1.900', '2.400', { v: '+%26', ton: 'iyi' }, 'konaklama ↑'],
            ['bursa kaplıca', 'Türkiye', '2.900', '2.900', { v: '%0', ton: 'soluk' }, 'sabit'],
          ]}
        />

        <Not tip="uyari" baslik="Bu tesisin ürünü tam da düşen tarafta">
          Keramet Ilıcası <strong>günübirlik açık termal havuz</strong>. Eylül'de düşen sorgular
          ("kaplıca", "termal havuz") tam olarak bu ürünün sorguları; yükselenler ("termal otel",
          "kaplıca otelleri") konaklama sorguları. Bu yüzden Eylül'ün doğru kurgusu
          <strong> daha az bütçe + sezon kapanış mesajı</strong>: "sezonun son günleri" iletişimi,
          ay ortasından sonra hava koşuluna göre yayının durdurulması.
        </Not>
      </Slayt>

      {/* ════════════ SLAYT 2 — KANIT ════════════ */}
      <Slayt
        no={2}
        etiket="Slayt 2 · Kanıt"
        accent="#0F766E"
        baslik="Ağustos'ta ödenen para marka talebini gerçekten yarattı. Şimdi o talep sahipsiz duruyor."
        spot="İki ayda ₺221 bin harcandı, 23,5 milyon gösterim alındı. Sonuç arama hacminde görünüyor: Keramet Ilıcası'nın adı Temmuz 2026'da ayda 14.800 kez arandı — bir yıl önce 2.900'dü. Beş kat büyüyen bu marka talebine Ağustos'ta Google'da ayrılan bütçe yalnızca ₺16.429."
        dipnot="Kaynak: canlı Meta Ads API (act_2095088354756210) ve Google Ads (6654294370) üzerinden /api/group/hupalupa/monthly; marka arama hacmi Keyword Planner. Hesapta lead/form dönüşümü tanımlı olmadığı için ölçülebilir tek sonuç erişim ve tıklamadır — bu sayfada bilerek ziyaret ya da ciro sayısı verilmemiştir."
      >
        <MetrikSira kolon={4}>
          <Metrik etiket="&quot;keramet ılıcası&quot; · Tem 2026" deger="14.800" alt="Tem 2025: 2.900 → 5,1×" ton="iyi" />
          <Metrik etiket="Ağustos harcama" deger={tl(189341)} alt="Temmuz: ₺32.062" />
          <Metrik etiket="Ağustos gösterim" deger="19,8 M" alt="CPM ₺9,55 — çok ucuz erişim" ton="iyi" />
          <Metrik etiket="Ağustos Google payı" deger={tl(16429)} alt="toplam bütçenin yalnızca %8,7'si" ton="kotu" />
        </MetrikSira>

        <Tablo
          baslik="Keramet Ilıcası — hesap açıldığından beri"
          basliklar={['Ay', 'Meta', 'Google', 'Toplam', 'Gösterim', 'Tık', 'CPM', 'CPC']}
          saga={[1, 2, 3, 4, 5, 6, 7]}
          satirlar={[
            ['Mart – Haziran 2026', { v: '—', ton: 'soluk' }, { v: '—', ton: 'soluk' }, { v: '₺0', ton: 'soluk' }, { v: '—', ton: 'soluk' }, { v: '—', ton: 'soluk' }, { v: '—', ton: 'soluk' }, { v: '—', ton: 'soluk' }],
            ['Temmuz 2026', '₺32.062', { v: '—', ton: 'soluk' }, '₺32.062', '3.679.898', '6.584', '₺8,71', '₺4,87'],
            [{ v: 'Ağustos 2026', kalin: true }, '₺172.912', '₺16.429', { v: '₺189.341', kalin: true }, '19.825.881', '40.443', '₺9,55', '₺4,68'],
          ]}
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
          <Not tip="iyi" baslik="Talep yaratma parası harcandı — hasat henüz yapılmadı">
            Marka aramasının bir yılda <strong>2.900'den 14.800'e</strong> çıkması, Meta'ya verilen paranın
            işini yaptığını gösteriyor: insanlar reklamı gördü, sonra tesisin adını Google'da aradı.
            Ama o aramanın karşılandığı yer olan Google'a Ağustos'ta bütçenin yalnızca <strong>%8,7'si</strong>
            gitti. Marka sorgusunda sayfa üstü teklif aralığının üst ucu <strong>₺6,40</strong> — yani bu,
            hesabın en ucuz trafiği ve şu an yeterince alınmıyor.
          </Not>
          <Not tip="riskli" baslik="Ölçüm boşluğu — üçüncü ayda da aynı yere gelmeyelim">
            Hesapta <strong>form, arama ya da rezervasyon dönüşümü tanımlı değil.</strong> İki aydır
            raporlanabilen tek şey erişim ve tıklama. Ağustos'ta 40.443 tıklamanın ne olduğunu bilmiyoruz.
            Eylül bütçesinin serbest bırakılmasının şartı, tesis sayfasında en azından
            <strong> telefon tıklaması ve yol tarifi tıklamasının</strong> dönüşüm olarak tanımlanmasıdır.
          </Not>
        </div>
      </Slayt>

      {/* ════════════ SLAYT 3 — TALEP ════════════ */}
      <Slayt
        no={3}
        etiket="Slayt 3 · Öneri"
        accent="#111827"
        baslik="Eylül 2026 önerimiz: ₺120.000 (−%36,6), ama Google 2,7 katına çıkıyor"
        spot="Toplam bütçe düşüyor çünkü günübirlik havuz talebi düşüyor. Buna karşılık Google payı ₺16.429'dan ₺45.000'e çıkıyor: Ağustos'ta yaratılan marka talebini hasat etmenin ve yükselen &quot;termal otel / kaplıca otelleri&quot; sorgularını yakalamanın tek yolu arama."
        dipnot="Tıklama projeksiyonu Ağustos'un gerçekleşen Google CPC'si (₺11,63 — ₺16.429 / 1.413 tık) üzerinden hesaplandı; Keyword Planner'ın ₺6,40'lık sayfa üstü teklif tahmini DEĞİL, gerçekleşen maliyet kullanıldı. Ziyaret ve ciro projeksiyonu, ölçüm kurulmadığı için bilerek verilmemiştir."
      >
        <MetrikSira kolon={4}>
          <Metrik etiket="Ağustos gerçekleşen" deger={tl(189341)} alt="Meta ₺172.912 + Google ₺16.429" />
          <Metrik etiket="Eylül önerisi" deger={tl(120000)} alt="−₺69.341 · −%36,6" ton="kotu" />
          <Metrik etiket="Google payı" deger={tl(45000)} alt="Ağustos ₺16.429 → 2,7×" ton="iyi" />
          <Metrik etiket="Beklenen arama tıklaması" deger="3.500 – 4.500" alt="Ağustos CPC ₺11,63 ile" ton="iyi" />
        </MetrikSira>

        <div>
          <div className="text-[11px] font-semibold text-gray-700 mb-2.5">Mecra dağılımı</div>
          <Dagilim
            toplam={120000}
            kalemler={[
              { ad: 'Meta (erişim + sezon kapanış)', tutar: 75000, renk: '#0F766E', not: 'Ağustos\'un %43\'ü' },
              { ad: 'Google Arama', tutar: 45000, renk: '#1D4ED8', not: 'marka + termal otel + Bursa' },
            ]}
          />
        </div>

        <Tablo
          baslik="Ağustos gerçekleşen → Eylül plan"
          basliklar={['Mecra', 'Ağustos', 'Eylül planı', 'Değişim', 'Eylül\'de ne değişiyor']}
          saga={[1, 2, 3]}
          sarmala={[4]}
          satirlar={[
            ['Meta Ads', '₺172.912', { v: '₺75.000', kalin: true }, { v: '−%57', ton: 'kotu' }, 'Erişim yarıdan aza iner. Mesaj "sezonun son günleri"ne döner, hedefleme Bursa ve komşu illerde daralır.'],
            ['Google Arama', '₺16.429', { v: '₺45.000', kalin: true }, { v: '+%174', ton: 'iyi' }, 'Üç grup: marka ("keramet ılıcası" 14.800/ay), kategori ("termal otel", "kaplıca otelleri"), yerel ("bursa kaplıca").'],
            [{ v: 'Toplam' }, '₺189.341', { v: '₺120.000' }, { v: '−%37', ton: 'kotu' }, ''],
          ]}
          vurguSonSatir
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
          <Not tip="uyari" baslik="15 Eylül hava kararı">
            Günübirlik açık havuzun talebi hava koşuluna bağlı. 15 Eylül'de Orhangazi hava tahmini
            gündüz <strong>25°C'nin altına</strong> inmişse Meta'daki günübirlik iletişimi durdurulur ve
            kalan bütçe Google'da <strong>gelecek sezon için marka aramasını</strong> beslemeye kayar.
            Bu karar tarihe değil sıcaklığa bağlanmıştır, çünkü geçen yılın deseni tek başına
            (Ağu 1.900 → Eyl 1.000) tesisin kendi sezonunu belirlemeye yetmez.
          </Not>
          <Not tip="riskli" baslik="Onaya bağlı şart">
            ₺45.000'lik Google bütçesi, tesis sayfasında <strong>telefon tıklaması + yol tarifi</strong>
            dönüşüm olarak tanımlandıktan sonra serbest bırakılır. Tanımlanmazsa Google ₺25.000'de tutulur
            ve ay ₺100.000 ile geçer. Üçüncü ayın sonunda yine "sadece erişim aldık" demek istemiyoruz.
          </Not>
        </div>

        <GrupSeridi vurgu="Keramet Ilıcası" />
      </Slayt>
    </Deck>
  );
}
